module.exports = __webpack_public_path__ + "img/file-copy.0044b53d.svg";